import useNotification from './useNotification';

export default () => {
  const { notificationState, setNotificationState } = useNotification();

  const triggerNotification = (message, severity = 'success', opened = true) => {
    setNotificationState({ message, severity, opened });
    setTimeout(() => {
      setNotificationState({ message: '', severity, opened: false });
    }, 5000);
  };

  return { triggerNotification, notificationState };
};
